/**
 * @generated SignedSource<<e22e52d6cbca99c6c086968411209a64>>
 * @relayHash a084d413dd1c739582abc18242499a98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6e2a04967cdb399711fc74b3c87c72247a2bf36cc8a334f0cde3b12c6ac03ef0

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "asapIssuer"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "mediaToken"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "mediaUrl"
    },
    v7 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLogo",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "fileId"
          }, {
            "kind": "ScalarField",
            "name": "url"
          }]
        }, {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": {
            "args": v2 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v3 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v4 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v5 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v6 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.mediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.mediaConfig"
        }, {
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v7 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "mediaConfig",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }, {
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, v7 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "6e2a04967cdb399711fc74b3c87c72247a2bf36cc8a334f0cde3b12c6ac03ef0",
      "metadata": {},
      "name": "hubBootstrapQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "cfeda0f6edbdd4e1062c4c01ad494a7c";
export default node;